import { Organization } from "./organization";

export type User = {
  id: string;
  username: string;
  coach_id: string;
  email: string;
  first_name: string;
  last_name: string;
  has_accepted_eula: boolean;
  privs: number;
  iat: number;
  coach?: User;
  coached_users?: any;
  organization_id: string;
  organization?: Organization;
  createdAt: Date;
  updatedAt: Date;
};

export enum UserRole {
  Client,
  Coach,
  OrgAdmin,
  Admin,
  Super = 10
}
